import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import './Layout.css';
function Layout() {
  const navigate = useNavigate();
  const admin = JSON.parse(localStorage.getItem('saskara_admin_info') || '{}');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const handleLogout = () => {
    localStorage.removeItem('saskara_admin_token');
    localStorage.removeItem('saskara_admin_info');
    navigate('/login');
  };
  const closeSidebar = () => setSidebarOpen(false);
  return (
    <div className="layout">
      {!sidebarOpen && (
        <button className="burger-btn" onClick={() => setSidebarOpen(true)}>☰</button>
      )}
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}
      <aside className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-brand">SASKARA<span>RECORD</span></div>
        <nav className="sidebar-nav">
          <NavLink to="/dashboard" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Dashboard</NavLink>
          <NavLink to="/artists" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Artists</NavLink>
          <NavLink to="/songs" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Rilis / Songs</NavLink>
          <NavLink to="/news" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Berita</NavLink>
          <NavLink to="/events" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Event</NavLink>
          <NavLink to="/products" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Produk / Store</NavLink>
          <NavLink to="/site-content" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Pengaturan Situs</NavLink>
          <NavLink to="/videos" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Video Hub</NavLink>
          <NavLink to="/partners" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Partner / Sponsor</NavLink>
          <NavLink to="/broadcast" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Broadcast Email</NavLink>
          <NavLink to="/promotions" onClick={closeSidebar} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>Promo & Diskon</NavLink>
        </nav>
        <div className="sidebar-footer">
          <div className="admin-name">{admin.name || 'Admin'}</div>
          <button className="logout-btn" onClick={handleLogout}>Logout</button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
export default Layout;
